import React from 'react';
import { Users, BookOpen, FileText, Clock } from 'lucide-react';
import styled from 'styled-components';

export const StatsGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const StatCard = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  padding: 1rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`;

export const StatContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StatInfo = styled.div``;

export const StatTitle = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 0.25rem;
`;

export const StatValue = styled.p`
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
`;

export const IconContainer = styled.div<{ variant: 'classes' | 'students' | 'lessons' | 'alerts' }>`
  padding: 0.5rem;
  border-radius: 9999px;
  background-color: ${({ variant }) => {
    switch (variant) {
      case 'classes':
        return '#eff6ff';
      case 'students':
        return '#ecfdf5';
      case 'lessons':
        return '#f3f0ff';
      case 'alerts':
        return '#fff7ed';
      default:
        return '#f3f4f6';
    }
  }};
  
  svg {
    color: ${({ variant }) => {
      switch (variant) {
        case 'classes':
          return '#2563eb';
        case 'students':
          return '#059669';
        case 'lessons':
          return '#7c3aed';
        case 'alerts':
          return '#d97706';
        default:
          return '#6b7280';
      }
    }};
  }
`;

interface Stats {
  totalClasses: number;
  totalStudents: number;
  activeAssignments: number;
  pendingReviews: number;
}

interface StatsGridProps {
  stats?: Stats;
}

const StatsGrid: React.FC<StatsGridProps> = ({ stats }) => {
  const statItems = [
    {
      title: 'Total Classes',
      value: stats?.totalClasses || 0,
      icon: BookOpen,
      variant: 'classes' as const
    },
    {
      title: 'Total Students',
      value: stats?.totalStudents || 0,
      icon: Users,
      variant: 'students' as const
    },
    {
      title: 'Active Assignments',
      value: stats?.activeAssignments || 0,
      icon: FileText,
      variant: 'lessons' as const
    },
    {
      title: 'Pending Reviews',
      value: stats?.pendingReviews || 0,
      icon: Clock,
      variant: 'alerts' as const
    }
  ];

  return (
    <StatsGridContainer>
      {statItems.map((item, index) => (
        <StatCard key={index}>
          <StatContent>
            <StatInfo>
              <StatTitle>{item.title}</StatTitle>
              <StatValue>{item.value}</StatValue>
            </StatInfo>
            <IconContainer variant={item.variant}>
              <item.icon size={20} />
            </IconContainer>
          </StatContent>
        </StatCard>
      ))}
    </StatsGridContainer>
  );
};

export default StatsGrid; 